import React from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  // Inline styling object to guarantee dark backgrounds and visible high-contrast text
  const styles = {
    footerWrapper: {
      backgroundColor: '#070a12',
      color: '#e2e8f0',
      borderTop: '1px solid rgba(255, 255, 255, 0.1)',
      fontFamily: 'system-ui, -apple-system, sans-serif',
    },
    gradientCyanText: {
      background: 'linear-gradient(135deg, #00f2fe 0%, #4facfe 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      fontWeight: 'bold',
    },
    footerLink: {
      color: '#94a3b8',
      textDecoration: 'none',
      fontSize: '0.9rem',
      transition: 'color 0.2s ease',
      display: 'inline-block',
      marginBottom: '8px',
    },
    heading: {
      color: '#ffffff',
      fontSize: '1.05rem',
      fontWeight: '600',
      marginBottom: '18px',
      letterSpacing: '0.5px',
    },
    socialIcon: {
      width: '36px',
      height: '36px',
      borderRadius: '50%',
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      border: '1px solid rgba(255, 255, 255, 0.15)',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#00f2fe',
      textDecoration: 'none',
      marginRight: '10px',
      fontSize: '0.9rem',
    },
    newsletterInput: {
      backgroundColor: 'rgba(255, 255, 255, 0.05)',
      border: '1px solid rgba(255, 255, 255, 0.15)',
      color: '#ffffff',
      borderRadius: '50px 0 0 50px',
      paddingLeft: '16px',
      fontSize: '0.85rem',
    },
    newsletterBtn: {
      background: 'linear-gradient(135deg, #00f2fe 0%, #4facfe 100%)',
      color: '#000000',
      border: 'none',
      fontWeight: '600',
      borderRadius: '0 50px 50px 0',
      padding: '0 20px',
      fontSize: '0.85rem',
    },
  };

  return (
    <footer style={styles.footerWrapper} className="pt-5 pb-4">
      <div className="container">
        <div className="row g-4 pb-4">
          
          {/* COLUMN 1: BRAND OVERVIEW & NEWSLETTER */}
          <div className="col-12 col-lg-4 pe-lg-4">
            <Link to="/" className="d-inline-block mb-3">
              <img
                src="img/logo.png"
                alt="Lidlbritain"
                width="220"
                className="img-fluid"
              />
            </Link>
            <p className="text-light opacity-75 small mb-4" style={{ lineHeight: '1.6' }}>
              Bridging complex enterprise challenges with modern cloud architectures, artificial intelligence, and scalable digital engineering solutions.
            </p>
            
            {/* Newsletter Subscription */}
            <h6 style={styles.heading}>Subscribe to Insights</h6>
            <div className="input-group mb-4">
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
                style={styles.newsletterInput}
              />
              <button className="btn" type="button" style={styles.newsletterBtn}>
                Join
              </button>
            </div>

            {/* Social Links */}
            <div className="d-flex">
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" style={styles.socialIcon} aria-label="LinkedIn">
                <i className="fa-brands fa-linkedin-in"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" style={styles.socialIcon} aria-label="Twitter">
                <i className="fa-brands fa-x-twitter"></i>
              </a>
              <a href="https://github.com" target="_blank" rel="noreferrer" style={styles.socialIcon} aria-label="GitHub">
                <i className="fa-brands fa-github"></i>
              </a>
            </div>
          </div>

          {/* COLUMN 2: SERVICES */}
          <div className="col-6 col-md-3 col-lg-2">
            <h6 style={styles.heading}>Services</h6>
            <ul className="list-unstyled mb-0">
              <li><Link to="/design-and-development" style={styles.footerLink}>Web Design & Dev</Link></li>
              <li><Link to="/mobile-app-development" style={styles.footerLink}>Mobile Development</Link></li>
              <li><Link to="/digital-marketing" style={styles.footerLink}>Digital Marketing</Link></li>
              <li><Link to="/infrastructure-development" style={styles.footerLink}>Infrastructure</Link></li>
              <li><Link to="/application-development" style={styles.footerLink}>App Development</Link></li>
              <li><Link to="/cloud-migration" style={styles.footerLink}>Cloud Migration</Link></li>
              <li><Link to="/product-engineering" style={styles.footerLink}>Product Engineering</Link></li>
            </ul>
          </div>

          {/* COLUMN 3: DIGITAL TRANSFORMATION & TECH */}
          <div className="col-6 col-md-3 col-lg-3">
            <h6 style={styles.heading}>Digital Transformation</h6>
            <ul className="list-unstyled mb-4">
              <li><Link to="/customer-experience-cpq" style={styles.footerLink}>Customer Experience & CPQ</Link></li>
              <li><Link to="/supply-chain-optimization" style={styles.footerLink}>Supply Chain Optimization</Link></li>
              <li><Link to="/big-data-analytics" style={styles.footerLink}>Big Data & Analytics</Link></li>
              <li><Link to="/ai-and-ml" style={styles.footerLink}>AI & Machine Learning</Link></li>
            </ul>

            <h6 style={styles.heading}>Technology Platforms</h6>
            <ul className="list-unstyled mb-0">
              <li><Link to="/microsoft-cloud-solutions" style={styles.footerLink}>Microsoft Cloud Solutions</Link></li>
              <li><Link to="/aws-cloud-solutions" style={styles.footerLink}>AWS Cloud Solutions</Link></li>
              <li><Link to="/sap-enterprise-systems" style={styles.footerLink}>SAP Enterprise Systems</Link></li>
            </ul>
          </div>

          {/* COLUMN 4: INDUSTRIES & QUICK LINKS */}
          <div className="col-12 col-md-6 col-lg-3">
            <h6 style={styles.heading}>Industries</h6>
            <ul className="list-unstyled mb-4">
              <li><Link to="/manufacturing-solutions" style={styles.footerLink}>Manufacturing Solutions</Link></li>
              <li><Link to="/healthcare-biotech-solutions" style={styles.footerLink}>Healthcare & Biotech</Link></li>
              <li><Link to="/automotive-solutions" style={styles.footerLink}>Automotive Solutions</Link></li>
              <li><Link to="/media-and-entertainment" style={styles.footerLink}>Media & Entertainment</Link></li>
            </ul>

            <h6 style={styles.heading}>Company</h6>
            <ul className="list-unstyled mb-0">
              <li><Link to="/about-us" style={styles.footerLink}>About Us</Link></li>
              <li><Link to="/contact" style={styles.footerLink}>Contact Us</Link></li>
              <li><Link to="/careers" style={styles.footerLink}>Careers</Link></li>
            </ul>
          </div>

        </div>

        {/* BOTTOM COPYRIGHT ROW */}
        <div className="border-top border-secondary border-opacity-25 pt-4 mt-2 d-flex flex-column flex-md-row justify-content-between align-items-center small text-light opacity-75">
          <p className="mb-2 mb-md-0">
            &copy; {currentYear} <span style={styles.gradientCyanText}>Lidlbritain</span>. All rights reserved.
          </p>
          <div className="d-flex gap-4">
            <Link to="/privacy-policy" style={styles.footerLink} className="mb-0">Privacy Policy</Link>
            <Link to="/terms-of-service" style={styles.footerLink} className="mb-0">Terms of Service</Link>
            <Link to="/security" style={styles.footerLink} className="mb-0">Security</Link>
          </div>
        </div>

      </div>
    </footer>
  );
};

export default Footer;